import { invariant } from '@seen/core/invariant'
import { type JSX, useContext, useLayoutEffect } from 'react'
import { useParams } from 'react-router'
import { LayoutModeContext } from '#src/contexts/LayoutModeContext.ts'
import { DeskPage } from '#src/pages/desks/DeskPage.tsx'

export function ParticipantDeskPage(): JSX.Element {
  const { patientId, deskId } = useParams()
  invariant(patientId, 'Patient ID is required')
  invariant(deskId, 'Desk ID is required')
  return <ParticipantDeskPageComponent key={`${patientId}-${deskId}`} />
}

function ParticipantDeskPageComponent(): JSX.Element {
  const setLayoutMode = useContext(LayoutModeContext)
  useLayoutEffect(() => {
    setLayoutMode?.('full')
    return () => setLayoutMode?.('auto')
  }, [setLayoutMode])
  return (
    <div className="size-full border-t">
      <DeskPage />
    </div>
  )
}
